import Vue from 'vue'
import App from './App.vue'
import './plugins/pp-vue-library'
import router from './router'
import store from './store'
import installVisitSessionManager from 'telehealth-visit_session_management-client'
import { Resizer } from 'sdk-widget-manager'
import browserDetect from 'vue-browser-detect-plugin'
import PpVueAnalytics from 'pp-vue-analytics'
import { datadogRum } from '@datadog/browser-rum'
import Vuelidate from 'vuelidate'

Vue.use(Resizer)
Vue.use(browserDetect)
Vue.use(Vuelidate)

const params = new URLSearchParams(window.location.search)

Vue.prototype.$vuetify = {
  rtl: false,
  lang: {
    t: (val) => val
  },
  theme: {
    dark: false
  },
  breakpoint: {
    mobile: true,
    mobileBreakpoint: 600
  },
  icons: {
    values: {
      prev: 'mdi-chevron-left',
      next: 'mdi-chevron-right',
      dropdown: 'mdi-chevron-down',
      first: 'mdi-page-first',
      last: 'mdi-page-last',
      unfold: 'mdi-unfold-more-horizontal'
    }
  }
}

Vue.prototype.$ppColors = {
  primary: params.get('primary')
}

Vue.use(PpVueAnalytics, router, {
  appGaId: process.env.VUE_APP_PP_GA_PROPERTY_ID,
  practiceGaId: params.get('ga_property_id'),
  category: 'simple-visit',
  trackEventPrefix: 'simple_visit',
  practiceUuid: params.get('practiceUuid')
})

Vue.config.productionTip = false

const socketUrl = window.Cypress ? 'socketUrl' : process.env.VUE_APP_VISIT_SESSION_MANAGEMENT_WS
const httpUrl = window.Cypress ? 'httpUrl' : process.env.VUE_APP_VISIT_SESSION_MANAGEMENT_DOMAIN
const httpKey = window.Cypress ? 'apiKey' : process.env.VUE_APP_VISIT_SESSION_MANAGEMENT_API_KEY

if (socketUrl && httpUrl && httpKey) {
  Vue.use(installVisitSessionManager, { store, socketUrl, httpUrl, httpKey, skipChannel: true })
}

datadogRum.init({
  applicationId: 'fb9e2223-1077-41e9-87a3-6eed8100b207',
  clientToken: 'pub631d56d34a95db0a838046df11aa5f11',
  env: process.env.VUE_APP_STAGE,
  version: process.env.VUE_APP_VERSION,
  sampleRate: 100,
  site: 'datadoghq.com',
  service: 'visit-telehealth-ui',
  useCrossSiteSessionCookie: true,
  trackInteractions: true,
  trackFrustrations: true,
  beforeSend: (event, context) => {
    // collect a RUM resource's response headers
    if (event.type === 'resource' && event.resource.type === 'fetch') {
      event.context = { ...event.context, responseHeaders: context.response.headers }
    }
  }
})

datadogRum.addRumGlobalContext('practiceUuid', params.get('practiceUuid'))

datadogRum.startSessionReplayRecording()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
